export interface Account {
  id: number;
  accountName: string;
  clientName: string;
  gmclientApiKey: string;
  aiReplies: boolean;
  jiraDeskIntegrationActivated: boolean;
  campaignsActivated: boolean;
  aiInsightsMode: AiInsightsMode;
}

export enum AiInsightsMode {
  DISABLED = 'DISABLED', // disable everything AI-Insights related
  ENABLED = 'ENABLED', // enable full functionality
  PREVIEW = 'PREVIEW', // disable functionality, tour, but show nav button + page teaser
}